var _desc, _defs, _rect, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.7628 0 0 19.7628 499.9989 499.9989)",
    id: 895244
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.1765 0.3847)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 22.6008
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.4474 0.3848)",
    clipPath: "url(#CLIPPATH_1)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.2709 0)",
    id: "clip0_64_14608",
    x: -13,
    y: -13.5,
    rx: 0,
    ry: 0,
    width: 26,
    height: 27
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(97,64,178)",
      fillOpacity: 0.54,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-22.5526, -23.3848)",
    d: "M 14.1567 21.6973 C 13.2576 21.6973 12.5317 22.451 12.5317 23.3848 C 12.5317 24.3185 13.2576 25.0723 14.1567 25.0723 C 15.0559 25.0723 15.7817 24.3185 15.7817 23.3848 C 15.7817 22.451 15.0559 21.6973 14.1567 21.6973 Z M 14.1567 14.9473 C 13.2576 14.9473 12.5317 15.701 12.5317 16.6348 C 12.5317 17.5685 13.2576 18.3223 14.1567 18.3223 C 15.0559 18.3223 15.7817 17.5685 15.7817 16.6348 C 15.7817 15.701 15.0559 14.9473 14.1567 14.9473 Z M 14.1567 28.4473 C 13.2522 28.4473 12.5317 29.2066 12.5317 30.1348 C 12.5317 31.0629 13.263 31.8223 14.1567 31.8223 C 15.0505 31.8223 15.7817 31.0629 15.7817 30.1348 C 15.7817 29.2066 15.0613 28.4473 14.1567 28.4473 Z M 17.4067 31.2598 H 32.5734 V 29.0098 H 17.4067 V 31.2598 Z M 17.4067 24.5098 H 32.5734 V 22.2598 H 17.4067 V 24.5098 Z M 17.4067 15.5098 V 17.7598 H 32.5734 V 15.5098 H 17.4067 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenButton);
export default __webpack_public_path__ + "static/media/open-button.2b6204295bcb42bd03b271025d173ccf.svg";
export { ForwardRef as ReactComponent };